// The share page's second bundle: pdfjs stays off every other PUBLIC page.
// public.js is included first, so the Stimulus application already exists.
import Public__PdfViewerController from "./controllers/public/pdf_viewer_controller"

window.Stimulus.register("public--pdf-viewer", Public__PdfViewerController)
